<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,
  },
  data() {
    return {
      title: "Mensagens de Rastreio",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Mensagens de Rastreio",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      errosValid: null,
      showModalMensagem: false,
      mensagemData: {}
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {


    salvarMensagem(){
      console.log('salvarMensagem')
      this.showModalMensagem = false
      this.updating = true
      api.post(`${getBaseUrl()}api/postmsgs`, {
        mensagemData: this.mensagemData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row.data)
      this.mensagemData = row.data
      this.showModalMensagem = true
    },


    abrirTrackerEvent(){
      console.log('abrirTrackerEvent')
      this.$router.push(`/trackerevents/list`)
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Mensagens de Rastreio'
    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)
      this.dataList = new CustomStore({
        key: "_id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/trackermsgss`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'S':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'E':
              corStatus = 'rgb(227,32,58)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      if (e.value === "A") {
        return 'A Enviar'
      } else if (e.value === "E") {
        return 'Erro'
      } else if (e.value === "S") {
        return 'Enviado'
      }
      else {
        return e.value
      }
    },
  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>
    <div>
      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="aligncenter"
              hint="Importar arquivo de movimento"
              text="Eventos de Rastreio"
              :on-click="abrirTrackerEvent"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @row-dbl-click="onRowDblClick"
          @cell-prepared="onCellPrepared"
          @content-ready="carregouGrid"
          @exporting="onExporting">
        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strTrackerMsgssList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="_id"
            sort-order="desc"
            caption="ID"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="left"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="status_detalhe"
            caption="Detalhe Status"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tracckerevent_id"
            caption="ID Evento"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origem"
            caption="Origem"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origem_id"
            caption="ID origem"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

          <DxColumn
            data-field="numero_nota"
            caption="NF"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tipo"
            caption="Tipo"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destnome"
            caption="Destinatário"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destcnpj"
            caption="CNPJ Destinatário"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


<!--        <DxColumn-->
<!--            data-field="destmail"-->
<!--            caption="E-mail"-->
<!--            data-type="text"-->
<!--            alignment="left"-->
<!--            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"-->
<!--            :allowHeaderFiltering="true"/>-->

        <DxColumn
            data-field="desttel"
            caption="Telefone"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="@timestamp"
            caption="Data"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="data_status"
            caption="Data Status"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="mensagem"
            caption="Mensagem"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>


    <b-modal size="xl" title="Detalhes Mensagem" v-model="showModalMensagem" centered hide-footer>

      <div class="row">

        <div class="col-md-2">
          <div class="mb-3">
            <label for="_id">ID</label>
            <input
                id="_id"
                v-model="mensagemData._id"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="ID"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="origem">Origem</label>
            <input
                id="origem"
                v-model="mensagemData.origem"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Origem"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="origem_id">Origem ID</label>
            <input
                id="origem_id"
                v-model="mensagemData.origem_id"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Origem ID"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="tipo">Tipo</label>
            <input
                id="tipo"
                v-model="mensagemData.tipo"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Tipo"/>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="mb-3">
            <label for="statusmsgs">Status</label>
            <select id="statusmsgs" v-model="mensagemData.status" class="form-control" :disabled="false">
              <option value="A">A Enviar</option>
              <option value="S">Enviado</option>
              <option value="E">Erro</option>
            </select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="destnome">Destinatário</label>
            <input
                id="destnome"
                v-model="mensagemData.destnome"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Destinatário"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="destcnpj">CNPJ</label>
            <input
                id="destcnpj"
                v-model="mensagemData.destcnpj"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="CNPJ"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="destmail">E-mail</label>
            <input
                id="destmail"
                v-model="mensagemData.destmail"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="E-mail"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="desttel">Telefone</label>
            <input
                id="desttel"
                v-model="mensagemData.desttel"
                type="text"
                class="form-control"
                :disabled="false"
                placeholder="Telefone"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="link">Link</label>
            <input
                id="link"
                v-model="mensagemData.link"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Link"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="datastatus">Data Status</label>
            <input
                id="datastatus"
                v-model="mensagemData.datastatus"
                type="date"
                class="form-control"
                :disabled="true"
                placeholder="Data Status"/>
          </div>
        </div>

      </div>


      <div class="row">

        <div class="col-sm-12">
          <div class="mb-3">
            <label for="mensagem">Mensagem</label>
            <textarea id="mensagem" v-model="mensagemData.mensagem" type="text" rows="15" class="form-control" :disabled="true"
                      placeholder="Mensagem" />
          </div>
        </div>

      </div>


      <div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalMensagem = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="salvarMensagem">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar Alterações
          </b-button>
        </div>

      </div>



    </b-modal>


  </Layout>
</template>
